// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__lfONy","title":"styles_title__msTn2","text":"styles_text__RaTOO","textFlex":"styles_textFlex__12Y7T"};